import React from 'react';
import styles from './ListHeader.module.scss';

const ListHeader = (props: {
    text?: string;
    aside?: React.ReactNode;
    children?: React.ReactNode;
}) => {
    return (
        <div className={styles.wrap}>
            <h2 className={styles.text}>{props.text ? props.text : ' '}</h2>
            {props.children}
            {props.aside && (
                <aside className={styles.aside}>{props.aside}</aside>
            )}
        </div>
    );
};

export default ListHeader;
